module.exports = __webpack_public_path__ + "static/console-table-10284ec1c37e66c5ee05348f4d7de9c8.mp4";